import { Landmark } from 'lucide-react'
import { type ComponentProps } from 'react'

import DisplayTooltipOnHover from 'components/reusable/DisplayTooltipOnHover'
import { Badge } from 'slab'
import { type BrokersBrokerMemberDenormalized } from 'utils/web_api.schemas'

function getBadgeTypeInfo (member: BrokersBrokerMemberDenormalized): {
  type: ComponentProps<typeof Badge>['type']
  text: string
  tooltipText: string
} | null {
  const approvedByUnit = member?.approved_by_unit

  if (approvedByUnit === undefined || approvedByUnit === null) {
    return null
  }

  if (approvedByUnit) {
    return {
      type: 'success',
      text: 'Unit App approved',
      tooltipText: 'This member has been approved by the unit',
    }
  } else {
    return {
      type: 'warning',
      text: 'Unit App pending',
      tooltipText: 'This member\'s unit application is still pending approval',
    }
  }
}

const UnitApprovalStatusBadge = ({
  member,
}: {
  member: BrokersBrokerMemberDenormalized
}) => {
  const badgeInfo = getBadgeTypeInfo(member)

  if (!badgeInfo) {
    return null
  }

  const { type, text, tooltipText } = badgeInfo

  return (
    <DisplayTooltipOnHover text={tooltipText} asChild>
      <Badge type={type} leftIcon={Landmark}>{text}</Badge>
    </DisplayTooltipOnHover>
  )
}

export default UnitApprovalStatusBadge
